// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 70rem;
  background: var(--white);
  border-radius: 1.2rem;
  box-shadow: 0 1.6rem 3.2rem rgba(44, 39, 56, 0.04), 0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);
  display: block;
}

.header {
  height: 5.6rem;
  color: var(--dlack);
  background: var(--white);
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header .title {
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  letter-spacing: 0.005em;
}
.header .icon-cancel {
  font-size: 1.8rem;
  cursor: pointer;
}

.content {
  padding: 3.4rem 2rem 4rem;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: var(--bg);
}
.content .col-name {
  width: 100%;
}
.content .col-value {
  width: 60%;
}
.content a[app-icon-button] {
  color: var(--red);
}
.content .actions {
  margin-top: 4rem;
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
}

.table-wrapper {
  background-color: var(--white);
  border-radius: 16px;
  padding: 20px 10px;
}

table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  text-align: center;
  color: var(--black);
}
table thead {
  background-color: rgba(225, 225, 251, 0.6);
  font-weight: 500;
  font-size: 11px;
  line-height: 120%;
  text-transform: uppercase;
  height: 4.8rem;
  color: #303240;
  box-shadow: 0px 1px 0px rgb(225, 227, 235);
}
table thead th {
  padding: 0 1rem;
  text-align: start;
}
table thead :first-child {
  text-align: start;
  box-shadow: 1px 0px 0px rgb(225, 227, 235);
}
table tbody {
  text-align: start;
}
table tbody {
  box-shadow: 0px 1px 0px rgb(225, 227, 235);
}
table tbody tr {
  border-bottom: 1px solid grey;
}
table tbody tr td {
  height: 4.8rem;
  background: var(--white);
  padding: 0 1rem;
  text-align: start;
  border: 0.1rem solid var(--white);
  align-items: center;
  transition: border-color 0.2s;
  position: relative;
  font-weight: 400;
  font-size: 12px;
  line-height: 120%;
}
table tbody tr td input[type=number] {
  width: 100%;
  height: 100%;
  text-align: end;
  box-sizing: border-box;
  font-weight: 400;
  font-size: 12px;
  line-height: 120%;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/tax-form-popup/tax-form-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,0FACE;EAEF,cAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAGE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;AAHF;AAKE;EACE,WAAA;AAHJ;AAME;EACE,UAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AANJ;;AAUA;EACE,8BAAA;EACA,mBAAA;EACA,kBAAA;AAPF;;AAUA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAPF;AASE;EACE,0CAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,cAAA;EACA,0CAAA;AAPJ;AASI;EACE,eAAA;EACA,iBAAA;AAPN;AAWE;EACE,iBAAA;EACA,0CAAA;AATJ;AAYE;EACE,iBAAA;AAVJ;AAcE;EACE,0CAAA;AAZJ;AAcI;EACE,6BAAA;AAZN;AAcM;EACE,cAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,iCAAA;EACA,mBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZR;AAcQ;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAZV","sourcesContent":[":host {\n  width: 70rem;\n  background: var(--white);\n  border-radius: 1.2rem;\n  box-shadow:\n    0 1.6rem 3.2rem rgba(44, 39, 56, 0.04),\n    0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);\n  display: block;\n}\n\n.header {\n  height: 5.6rem;\n  color: var(--dlack);\n  background: var(--white);\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & .title {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 120%;\n    letter-spacing: 0.005em;\n  }\n\n  & .icon-cancel {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n\n.content {\n  padding: 3.4rem 2rem 4rem;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  background: var(--bg);\n\n  & .col-name {\n    width: 100%;\n  }\n\n  & .col-value {\n    width: 60%;\n  }\n\n  a[app-icon-button] {\n    color: var(--red);\n  }\n\n  & .actions {\n    margin-top: 4rem;\n    display: flex;\n    justify-content: flex-start;\n    gap: 2rem;\n  }\n}\n\n.table-wrapper {\n  background-color: var(--white);\n  border-radius: 16px;\n  padding: 20px 10px;\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: fixed;\n  text-align: center;\n  color: var(--black);\n\n  thead {\n    background-color: rgba(225, 225, 251, 0.6);\n    font-weight: 500;\n    font-size: 11px;\n    line-height: 120%;\n    text-transform: uppercase;\n    height: 4.8rem;\n    color: #303240;\n    box-shadow: 0px 1px 0px rgba(225, 227, 235, 1);\n\n    th {\n      padding: 0 1rem;\n      text-align: start;\n    }\n  }\n\n  thead :first-child {\n    text-align: start;\n    box-shadow: 1px 0px 0px rgba(225, 227, 235, 1);\n  }\n\n  tbody {\n    text-align: start;\n    // box-shadow: 1px 0px 0px rgba(225, 227, 235, 1);\n  }\n\n  tbody {\n    box-shadow: 0px 1px 0px rgba(225, 227, 235, 1);\n\n    tr {\n      border-bottom: 1px solid grey;\n\n      td {\n        height: 4.8rem;\n        background: var(--white);\n        padding: 0 1rem;\n        text-align: start;\n        border: 0.1rem solid var(--white);\n        align-items: center;\n        transition: border-color 0.2s;\n        position: relative;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 120%;\n\n        input[type='number'] {\n          width: 100%;\n          height: 100%;\n          text-align: end;\n          box-sizing: border-box;\n          font-weight: 400;\n          font-size: 12px;\n          line-height: 120%;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
